export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'system-tools',
    name: '系统工具',
    description: '系统优化、清理加速、驱动管理、文件管理等系统级工具软件',
    icon: 'ri-computer-line',
    articleCount: 42,
  },
  {
    slug: 'office-tools',
    name: '办公软件',
    description: '文档处理、表格编辑、演示制作、PDF工具等办公必备软件',
    icon: 'ri-file-text-line',
    articleCount: 35,
  },
  {
    slug: 'multimedia',
    name: '多媒体处理',
    description: '视频编辑、音频转换、图像处理、屏幕录制等多媒体工具',
    icon: 'ri-film-line',
    articleCount: 28,
  },
  {
    slug: 'network-tools',
    name: '网络工具',
    description: '下载加速、远程控制、网络检测、数据恢复等网络相关工具',
    icon: 'ri-wifi-line',
    articleCount: 31,
  },
  {
    slug: 'security-tools',
    name: '安全防护',
    description: '杀毒防护、隐私保护、密码管理、数据加密等安全类工具',
    icon: 'ri-shield-check-line',
    articleCount: 24,
  },
  {
    slug: 'dev-tools',
    name: '开发工具',
    description: '代码编辑、版本管理、数据库工具、API测试等开发辅助工具',
    icon: 'ri-code-s-slash-line',
    articleCount: 19,
  },
];